module.exports = __webpack_public_path__ + "static/img/5.a550d76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/5.jpg
// module id = R160
// module chunks = 2